import React from 'react';
import Main from './Main';
import ShareButtons from './ShareButtons';
import './NewsArticle.css';
import { $$, MD } from '../utils/Utils';
import * as DATA from '../utils/Data';

export default class NewsArticle extends React.Component {
  componentDidUpdate() {
    let arrImgs = $$('.article__text p img');
    arrImgs.forEach(el => {
      el.insertAdjacentHTML('afterend', `<figcaption>${el.alt}</figcaption>`);
    });
  }

  render() {
    if (this.props.newsItem.imagen) {
      return (
        <Main>
          <div className="news-article-content">
            <section className="section news-article">
              <h2 className="section-title">
                Notas
                <i className="material-icons">chevron_right</i>
                <span>{this.props.newsItem.fecha}</span>
              </h2>
              <div className="article-grid">
                <article className="article">
                  <div className="article__header">
                    <div className="article__quote">{this.props.newsItem.titulo}</div>
                  </div>
                  <div className="article__main">
                    <div className="article__sidebar">
                      <img src={DATA.SERVER_URL + this.props.newsItem.imagen.data.url} alt="" />
                      <ShareButtons data={this.props.newsItem} url={window.location.href} title={this.props.newsItem.titulo} image={DATA.SERVER_URL + this.props.newsItem.imagen.data.url} />
                    </div>
                    <div
                      className="article__text"
                      dangerouslySetInnerHTML={{
                        __html: MD.render(this.props.newsItem.texto)
                      }}
                    />
                  </div>
                </article>
              </div>
            </section>
          </div>
        </Main>
      );
    }
    return (
      <Main>
        <div className="news-article-content" />
      </Main>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NewsArticle.js